// Build provenance surfaced in the footer "Build info" chip. The values are
// injected at build time as REACT_APP_* env vars (see Dockerfile.prod, which is
// fed GIT_SHA=github.sha + BUILD_TIME from the CI workflow). CRA inlines any
// REACT_APP_* var present at build into the bundle. In local dev these are
// absent, so everything falls back to "dev".
const GITHUB_REPO_URL = "https://github.com/keroger2k/stats-frontend";

const rawSha = process.env.REACT_APP_GIT_SHA?.trim();
const rawBuildTime = process.env.REACT_APP_BUILD_TIME?.trim();

export interface BuildInfo {
  /** Full commit SHA, or null in local dev / unbuilt environments. */
  sha: string | null;
  /** 7-char short SHA, or "dev" when no SHA was injected. */
  shortSha: string;
  /** GitHub link to the exact commit, or null in dev. */
  commitUrl: string | null;
  /** Parsed build timestamp, or null if absent/unparseable. */
  buildTime: Date | null;
  /** Deploy environment (PRODUCTION / STAGING / development). */
  environment: string;
}

export const buildInfo: BuildInfo = (() => {
  const sha = rawSha && rawSha.length > 0 ? rawSha : null;
  const parsed = rawBuildTime ? new Date(rawBuildTime) : null;
  const buildTime = parsed && !Number.isNaN(parsed.getTime()) ? parsed : null;

  return {
    sha,
    shortSha: sha ? sha.slice(0, 7) : "dev",
    commitUrl: sha ? `${GITHUB_REPO_URL}/commit/${sha}` : null,
    buildTime,
    environment: process.env.REACT_APP_ENV ?? process.env.NODE_ENV ?? "development",
  };
})();
